require('./mb-header-pdf-viewer-hybrid.scss');

// vendors
import React, { useRef } from 'react';

// components
import { OKButton } from 'commonsComponents/OKButton';

// utils
import { isIosWebView } from '../../../utilities/migration.utils';

const { FormattedText } = require('core/i18n').i18n;

export const stickElementToTop = element => {
  elements.push(element);
};

const MbHeaderPdfViewerHybrid = props => {
  const { handleClickButton, linkText, title, withTitle = false } = props;

  const myRef = useRef(null);
  React.useEffect(() => {
    if (isIosWebView()) {
      stickElementToTop(myRef.current);
    }
  }, []);

  return (
    <div ref={myRef} className="mb-header-wrapper">
      <div className="mb-header-content">
        <div className="mb-left-icon-section">
          <OKButton modifier="link-ghost" onClick={handleClickButton} disabled={false}>
            <FormattedText value={linkText} />
          </OKButton>
        </div>
        {withTitle && (
          <div className="mb-title-section">
            <div className="mb-title">{title}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MbHeaderPdfViewerHybrid;
